module.exports = __webpack_public_path__ + "static/antd-datepicker-custom-cells-ee5cf247de4e9a0a5866b3a5072d0c78.png";